import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetAtom } from 'jotai';
import { addToastAtom } from '../../../atoms/v0';
import { uploadImageAtom } from '../../../atoms/v0';

/**
 * 提供图片上传相关功能的钩子
 */
export const useImageUpload = () => {
  const { t } = useTranslation(['v0/chat']);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const uploadImage = useSetAtom(uploadImageAtom);
  const addToast = useSetAtom(addToastAtom);

  // 处理文件选择
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // 检查文件类型
      if (!file.type.match('image.*')) {
        addToast({
          title: t('v0/chat:fileTypeError'),
          description: t('v0/chat:fileTypeErrorDescription'),
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      
      // 检查文件大小 (8MB 限制)
      if (file.size > 8 * 1024 * 1024) {
        addToast({
          title: t('v0/chat:fileSizeError'),
          description: t('v0/chat:fileSizeErrorDescription'),
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
        return;
      }
      
      setImageFile(file);
      
      // 创建预览
      const reader = new FileReader();
      reader.onload = (event) => {
        setImagePreview(event.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };
  
  // 处理图片上传点击
  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  
  // 清除选中的图片
  const clearSelectedImage = () => {
    setImageFile(null);
    setImagePreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return {
    imageFile,
    setImageFile,
    imagePreview,
    setImagePreview,
    fileInputRef,
    handleFileChange,
    handleUploadClick,
    clearSelectedImage,
    uploadImage
  };
}; 